import { render, staticRenderFns } from "./commandlist.vue?vue&type=template&id=16d60eec&"
import script from "./commandlist.vue?vue&type=script&lang=ts&"
export * from "./commandlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "commandlist.vue"
export default component.exports